/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Row_SupplementInputs */

const en_us2_profile_row_supplement = /** @type {(inputs: Profile_Row_SupplementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supplement`)
};

const pt_br2_profile_row_supplement = /** @type {(inputs: Profile_Row_SupplementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suplemento`)
};

const es_419_profile_row_supplement = /** @type {(inputs: Profile_Row_SupplementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suplemento`)
};

const pt_pt2_profile_row_supplement = /** @type {(inputs: Profile_Row_SupplementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suplemento`)
};

const fr_fr2_profile_row_supplement = /** @type {(inputs: Profile_Row_SupplementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complément`)
};

const de_de2_profile_row_supplement = /** @type {(inputs: Profile_Row_SupplementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supplement`)
};

const it_it2_profile_row_supplement = /** @type {(inputs: Profile_Row_SupplementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integratore`)
};

/**
* | output |
* | --- |
* | "Supplement" |
*
* @param {Profile_Row_SupplementInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_row_supplement = /** @type {((inputs?: Profile_Row_SupplementInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Row_SupplementInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_row_supplement(inputs)
	if (locale === "es-419") return es_419_profile_row_supplement(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_row_supplement(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_row_supplement(inputs)
	if (locale === "de-DE") return de_de2_profile_row_supplement(inputs)
	if (locale === "it-IT") return it_it2_profile_row_supplement(inputs)
	return en_us2_profile_row_supplement(inputs)
});
export { profile_row_supplement as "profile.row_supplement" }